export const localhost = {
    api: {
        url: 'http://localhost:5001/api/v1/',
        mode: 'cors',
        AUTH: 'Basic b3B0aWZvX2FkbWluOm9wdGlmb0AxMjM='
    }
}

export const development = {
    api: {
        url: 'https://optifo.in/api/v1/',
        mode: 'cors',
        AUTH: 'Basic b3B0aWZvX2FkbWluOm9wdGlmb0AxMjM='
    }
}


export const staging = {
    api: {
        url: 'https://stagapi.optifo.com/api/v1/',
        mode: 'cors',
        AUTH: 'Basic b3B0aWZvX2FkbWluOm9wdGlmb0AxMjM='
    }
}
export const production = {
    api: {
        url: 'https://prodapi.optifo.com/api/v1/',
        mode: 'cors',
        AUTH: 'Basic b3B0aWZvX2FkbWluOm9wdGlmb0AxMjM='
    }
}
